/* Copyright (c) 2020-present CloudIO Inc */

import { ChartjsItem } from 'componentregistry/components/Chartjs/Chartjs';
import { pageAtom } from 'designer/atoms';
import {
  AnalyzeContext,
  AnalyzeIssue,
  AnalyzeResult,
} from 'layout/Sidebar/panels/TreeView/AnalyzeUtils';
import { Item } from '../../registry/Component.type';

export async function analyzeActionQueryChart({
  page,
  itemId,
  mgr,
  platform,
  appUid,
  pageId,
}: AnalyzeContext): Promise<AnalyzeResult> {
  const alerts: AnalyzeIssue[] = [];
  const autoFixes: (() => void)[] = [];
  const item = page[itemId] as Item<'ActionQueryChart'>;
  const { chartItemId } = item.props;
  if (chartItemId) {
    const chartItem = platform.getItem(
      appUid,
      pageId,
      chartItemId,
    ) as ChartjsItem;
    if (!chartItem.props.doNotPrefetch) {
      alerts.push({
        key: `select-not-prefetch-${chartItemId}`,
        showItemId: chartItemId,
        alert: `${mgr.name} exists for Chart with itemId [${chartItemId}]. Hence the it should have 'Do not prefetch' checked!`,
        itemId,
        severity: 'warning',
        fix: () => {
          const _page = { ...platform.getPage(appUid, pageId) };
          const _item = _page[chartItemId] as ChartjsItem;
          let updatedItem = _item;
          updatedItem = {
            ...updatedItem,
            props: {
              ...updatedItem.props,
              doNotPrefetch: true,
            },
          };
          _page[_item.itemId] = updatedItem;
          platform.setter(pageAtom, _page, {
            params: { appUid, pageId },
          });
        },
      });
    }
  }
  return [alerts, autoFixes];
}
